import '../../styles/blocks/_product.scss';
import '../../styles/blocks/_investment-fund.scss';
import '../../styles/blocks/_initial.scss';

import React, { Fragment, PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import classNames from 'classnames';
import cryptoJS from 'crypto-js';
import advantagesIcon from '../../assets/icons/solidarity-advantages-icon.svg';
import donationsIcon from '../../assets/icons/solidarity-donations-icon.svg';
import infoIcon from '../../assets/icons/solidarity-info-icon.svg';
import preLoaderActions from 'actions/preLoaderActions';
import productsActions from 'actions/productsActions';
import wealthProductActions from 'actions/wealthProductActions';
import cmsActions from 'actions/cmsActions';
import promotionalCodeAction from 'actions/promotionalCodeAction';
import stepsActions from 'actions/stepsActions';
import CreditCardOffer from 'components/creditCardOffer/creditCardOffer';
import CreditCardOfferInfoModal from 'components/creditCardOfferInfoModal/creditCardOfferInfoModal';
import { InitialStepDispatcher } from 'components/newAccountSteps/initialStep/InitialStepDispatcher';
import { PromotionalCodeContainer as PromotionalCode } from 'components/promotionalCode/PromotionalCodeContainer';
import TitleBox from 'components/commons/titleBox/titleBox';
import { InfoTooltip } from 'components/tooltip/tooltip';
import { HTMLSafeInjector } from 'commonsComponents/htmlSafeInjector';
import OkModalOnboarding from 'components/commons/OkModalOnboarding/OkModalOnboarding';
import { OKLink } from 'commonsComponents/OKLink';
import CreditCardInitialInfoSection from 'components/CreditCardComponents/CreditCardInitialSection/CreditCardInitialInfoSection/CreditCardInitialInfoSection';
import CreditCardProcessRequeriments from 'components/CreditCardComponents/CreditCardProcessRequeriments/CreditCardProcessRequeriments';
import CreditCardInitialAdditionalInfoSection from 'components/CreditCardComponents/CreditCardInitialSection/CreditCardInitialAdditionalInfoSection/CreditCardInitialAdditionalInfoSection';
import CreditCardLightHeader from 'components/CreditCardComponents/CreditCardLightHeader/CreditCardLightHeader';
import Storage from 'utilities/storage';
import { FormattedText, formatText, getLanguage } from 'core/i18n';
import { renderSolidaryModal } from 'utilities/logicByCountry';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import {
    validateCreditCardPath,
    isCreditCardPath,
    isCreditCardPathLight,
    getCreditCardLightTypeByPath,
} from 'utilities/creditCard/creditCard';
import { sanetizeUrl } from 'utilities/onboardingTypeHelper';
import arrowIcon from 'assets/icons/icon-arrow.svg';
import { recordPromoCode, recordEvent, PAGE_INITIAL, errorTag } from 'utilities/uTagging';
import { PATH_OPEN_YOUR_ACCOUNT } from 'constants/uTagConstants/paths';
import { TRADITIONAL, ROBO, GBI, CREDIT_CARD, CREDIT_CARD_LIGHT } from 'constants/userProfile';
import { FUNDS, PLANS, PORTFOLIO, ISIN, DGS, INVD } from 'constants/products';
import { REGISTER_TEXT, REGISTER_TOOLTIP } from 'constants/cms';
import { ROBO_PATH, GBI_PATH } from 'constants/pathInvestments';
import { OPENCREDIT } from 'constants/featureFlagging';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class Initial extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            showCreditCardInfoModal: false,
            showSolidaryModal: false,
        };

        this.onHandleValidPromoCode = this.onHandleValidPromoCode.bind(this);
        this.onHandleNotValidPromoCode = this.onHandleNotValidPromoCode.bind(this);
        this.getWealthProduct = this.getWealthProduct.bind(this);
        this.handleCreditCardOfferingChange = this.handleCreditCardOfferingChange.bind(this);
        this.handleCreditCardInfoModalVisibility = this.handleCreditCardInfoModalVisibility.bind(this);
        this.triggerEvent = this.triggerEvent.bind(this);
        this.triggerLink = this.triggerLink.bind(this);
    }

    UNSAFE_componentWillMount() {
        const jointHolderInvite = Storage.cookies.get('jointHolderInvite');
        if (jointHolderInvite) {
            window.location.href = atob(jointHolderInvite);
        }
    }

    componentDidMount() {
        const { preLoaderActions, wealthProductActions, cmsActions, formActions } = this.props;
        const wealthProduct = this.getWealthProduct();
        const promoCode = this.props.match.params.code;

        if (wealthProduct.type) {
            preLoaderActions.showPreLoader();
            wealthProductActions.getWealthProduct(wealthProduct, (valid, error) => {
                if (!valid) {
                    const errorDescription =
                        wealthProduct.type === INVD ? 'ERROR AL OBTENER DATOS DE CARTERA' : error.body.errorDescription;
                    errorTag(error.body, PATH_OPEN_YOUR_ACCOUNT, error.req.url, error.statusCode, errorDescription);
                }
            });
        }

        if (typeof promoCode !== 'undefined' && ![FUNDS, PLANS, PORTFOLIO].includes(promoCode.toLowerCase())) {
            preLoaderActions.showPreLoader();
        }

        cmsActions.getCMS(REGISTER_TEXT, REGISTER_TOOLTIP);
        formActions.change('userProfile.investmentType', this.getInvestmentType());
    }

    componentDidUpdate(prevProps) {
        const { userProfile, promotionalCodeAction, promotionalCode } = this.props;
        if (
            userProfile.investmentType !== prevProps.userProfile.investmentType &&
            prevProps.userProfile.investmentType
        ) {
            const promoCode = promotionalCode.getIn(['promotionalCode', 'code']);
            const language = getLanguage();
            promotionalCodeAction.getPromotion(promoCode, language, () => {});
        }
    }

    onHandleValidPromoCode(dataObject) {
        const { userProfile, preLoaderActions, productsActions } = this.props;
        const { investmentType } = userProfile;
        productsActions.setProductsInfo(dataObject, () => {
            preLoaderActions.hidePreLoader();
        });
        recordPromoCode('codigo promocional correcto', userProfile.promoCode, investmentType ? investmentType : '');
    }

    onHandleNotValidPromoCode() {
        const { preLoaderActions, formActions } = this.props;
        formActions.change('userProfile.promoCode', '');
        preLoaderActions.hidePreLoader();
    }

    handleCreditCardOfferingChange(checked) {
        const {
            match: {
                params: { code },
            },
            userProfile,
            productsActions,
        } = this.props;
        const codeId = (code && decodeURI(code)) || userProfile.promoCode;
        const language = getLanguage();

        productsActions.getCreditCardOffer(checked, codeId, language);
    }

    handleSuccessModal = () => {
        this.handleCreditCardOfferingChange(true);
        this.props.formActions.change('userProfile.creditCardOffer_accepted', true);
        this.handleCreditCardInfoModalVisibility();
    };

    handleCreditCardInfoModalVisibility() {
        const { userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        this.setState(
            prevState => ({
                showCreditCardInfoModal: !prevState.showCreditCardInfoModal,
            }),
            () => {
                if (this.state.showCreditCardInfoModal) {
                    recordEvent(
                        PATH_OPEN_YOUR_ACCOUNT,
                        PAGE_INITIAL,
                        'modal mas información tarjeta de crédito',
                        'modal mas información tarjeta de crédito desplegado',
                        '',
                        '',
                        '',
                        userProfile.investmentType,
                        docNumberEncrypted
                    );
                }
            }
        );
    }

    triggerEvent() {
        const precontractual = document.getElementById('precontractual');
        const { userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        recordEvent(
            PATH_OPEN_YOUR_ACCOUNT,
            PAGE_INITIAL,
            'tooltip tarjeta de crédito',
            'tooltip tarjeta de crédito desplegado',
            '',
            '',
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );

        if (precontractual) {
            precontractual.addEventListener('click', this.triggerLink);
        }
    }

    buildCard() {
        return (
            <div className="col-sm-6 product-description--request">
                <TitleBox
                    title={formatText('productDescription-request')}
                    dash="dash"
                    subTitle={formatText('productDescription-openCredit')}
                    paragraph={formatText('productDescription-aclaration')}
                    container="--request"
                    titleModifier="--register"
                    subTitleModifier="--request"
                    paragraphModifier="--request"
                />
            </div>
        );
    }

    buildBrokerHeader(name) {
        return (
            <span>
                {name.slice(0, name.indexOf('+') - 1)}
                <br />
                <span style={{ fontSize: 16 }}>{name.slice(name.indexOf('+'), name.length)}</span>
            </span>
        );
    }

    buildWealthProduct(name) {
        const { wealthProduct } = this.props;
        const wealthName = wealthProduct.get('wealthName');
        let upperTitle, tooltip, subTitle, important;

        switch (wealthProduct.get('wealthType')) {
            case ISIN:
                const nameISIN = formatText('investmentFund-name');
                const thisNameISIN = formatText('investmentFund-thisName');
                upperTitle = formatText('investmentFund-upperTitle');
                tooltip = formatText('investmentFund-tooltip', [nameISIN]);
                subTitle = formatText('investmentFund-subTitle', [thisNameISIN]);
                important = formatText('investmentFund-important', [nameISIN]);
                break;
            case DGS:
                const nameDGS = formatText('pensionPlan-name');
                const thisNameDGS = formatText('pensionPlan-thisName');
                upperTitle = formatText('pensionPlan-upperTitle');
                tooltip = formatText('investmentFund-tooltip', [nameDGS]);
                subTitle = formatText('investmentFund-subTitle', [thisNameDGS]);
                important = formatText('investmentFund-important', [nameDGS]);
                break;
            case INVD:
                const nameINVD = formatText('portfolio-name');
                const thisNameINVD = formatText('portfolio-thisName');
                upperTitle = formatText('portfolio-upperTitle');
                tooltip = formatText('investmentFund-tooltip', [nameINVD]);
                subTitle = formatText('investmentFund-subTitle', [thisNameINVD]);
                important = formatText('investmentFund-important', [nameINVD]);
                break;
            default:
                break;
        }

        return (
            <div className="investment-fund">
                <div className="investment-fund__text">{upperTitle}</div>
                <div className="investment-fund__title">{wealthName}</div>
                <div className="investment-fund__text">{subTitle}</div>
                <div className="investment-fund__products">
                    {name}
                    <InfoTooltip text={tooltip} />
                </div>
                <div className="investment-fund__information">
                    <i className="icons icons--icon-info"></i>
                    <span>{important}</span>
                </div>
                <hr />
            </div>
        );
    }

    getWealthProduct() {
        let type = null;
        let code = null;

        if (typeof this.props.match.params.isin !== 'undefined') {
            type = ISIN;
            code = this.props.match.params.isin;
        } else if (typeof this.props.match.params.dgs !== 'undefined') {
            type = DGS;
            code = this.props.match.params.dgs;
        } else if (typeof this.props.match.params.invd !== 'undefined') {
            type = INVD;
            code = this.props.match.params.invd;
        }

        return {
            type,
            code,
        };
    }

    buildSelectedPromoCode() {
        const {
            match: {
                params: { code },
            },
        } = this.props;
        const promoCode = code && decodeURI(code);
        let selectedPromoCode;

        if (promoCode && ![FUNDS, PLANS, PORTFOLIO].includes(promoCode.toLowerCase())) {
            selectedPromoCode = (
                <div className="promo-code">
                    <PromotionalCode
                        class="promo-code__details--top"
                        defaultPromoCode={promoCode}
                        isValid={this.onHandleValidPromoCode}
                        isNotValid={this.onHandleNotValidPromoCode}
                    />
                </div>
            );
        }

        return selectedPromoCode;
    }

    triggerLink() {
        const { userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        recordEvent(
            PATH_OPEN_YOUR_ACCOUNT,
            PAGE_INITIAL,
            'precontractual tarjeta de crédito',
            'precontractual tarjeta de crédito desplegado',
            '',
            '',
            '',
            userProfile.investmentType,
            docNumberEncrypted
        );
    }

    getRegisterText() {
        const { cms } = this.props;
        const cmsRegisterText = cms.getIn(['cmsRegister', 'text']);
        let result = '';

        if (cmsRegisterText) {
            result = <HTMLSafeInjector inline={true} message={cmsRegisterText} />;
        }

        return result;
    }

    getTooltipText() {
        const { cms } = this.props;
        const cmsTooltipFormat = cms.getIn(['cmsRegister', 'tooltip']).replace('<a', '<a id=precontractual ');
        let result = '';

        if (cmsTooltipFormat) {
            result = <HTMLSafeInjector message={cmsTooltipFormat} />;
        }

        return result;
    }

    buildCreditCardOffering() {
        const { cms, userProfile } = this.props;
        const isTraditionalUser = userProfile.investmentType === TRADITIONAL;
        let text = formatText('CMS-registerTCText');
        let tooltip = <FormattedText value="CMS-registroTCTooltip" />;
        let format = null;
        if (cms.getIn(['cmsRegister', 'text']) && cms.getIn(['cmsRegister', 'tooltip'])) {
            format = cms.getIn(['cmsRegister', 'tooltip']).replace('<a', '<a id=precontractual ');
            text = (
                <HTMLSafeInjector inline={true} message={cms.getIn(['cmsRegister', 'text']).replace(/p>/g, 'span>')} />
            );
            tooltip = <HTMLSafeInjector message={format} />;
        }
        const label = (
            <span>
                <FormattedText value="initial-creditCardOfferLabel" />
                <a
                    className="credit-card-offer__label-link"
                    href="#"
                    onClick={event => {
                        event.preventDefault();
                        this.handleCreditCardInfoModalVisibility();
                    }}
                >
                    <FormattedText value="creditCardOffer-infoModalLinkIconLabel" />
                    <img className="credit-card-offer__label-icon" src={arrowIcon} alt="" />
                </a>
            </span>
        );
        const subLabel = (
            <div className="credit-card-offer__sublabel">
                {text}
                <InfoTooltip text={tooltip} triggerEvent={this.triggerEvent} />
            </div>
        );

        const classCreditCardStyles = classNames('credit-card-offer__initial-container', {
            nomargin: isTraditionalUser,
        });

        return (
            <div className={classCreditCardStyles}>
                <CreditCardOffer
                    label={label}
                    onChange={this.handleCreditCardOfferingChange}
                    subLabel={subLabel}
                    {...this.props}
                />
                <CreditCardOfferInfoModal
                    show={this.state.showCreditCardInfoModal}
                    onClose={event => {
                        event.preventDefault();
                        this.handleCreditCardInfoModalVisibility();
                    }}
                    onSuccess={this.handleSuccessModal}
                    disabled={userProfile.creditCardOffer_accepted}
                />
            </div>
        );
    }

    handlePromoCode() {
        const { userProfile, formActions } = this.props;
        if (typeof userProfile.promoCode === 'undefined' || userProfile.promoCode == null) {
            formActions.reset('userProfile.promoCode');
            formActions.change('userProfile.withConfigCard', false);
        }
    }

    handleOpenSolidaryModal = open => {
        this.setState({ showSolidaryModal: open });
    };

    renderSolidaryModalFooter = () => {
        return (
            <button className="form__button form__button-secondary" onClick={() => this.handleOpenSolidaryModal(false)}>
                <FormattedText value="productDescriptionSolidary-button" />
            </button>
        );
    };

    renderSolidayModal = () => {
        const content = (
            <div className="initial__solidary-modal-body">
                <div className="initial__title">
                    <FormattedText value="productDescriptionSolidary-title" />
                </div>
                <div className="initial__solidary-modal-subtitle">
                    <FormattedText value="productDescriptionSolidary-subTitle" />
                </div>
                <div className="initial__solidary-modal-desc">
                    <div className="initial__solidary-modal-desc-box">
                        <div className="initial__solidary-modal-circle">
                            <img src={infoIcon} className="solidarity-icon-info" />
                        </div>
                        <div className="initial__box-title">
                            <FormattedText value="productDescriptionSolidary-box1Title" />
                        </div>
                        <div className="initial__box-desc">
                            <FormattedText value="productDescriptionSolidary-box1SubTitle" />
                        </div>
                    </div>
                    <div className="initial__solidary-modal-desc-box">
                        <div className="initial__solidary-modal-circle">
                            <img src={donationsIcon} className="solidarity-icon" />
                        </div>
                        <div className="initial__box-title">
                            <FormattedText value="productDescriptionSolidary-box2Title" />
                        </div>
                        <div className="initial__box-desc">
                            <FormattedText value="productDescriptionSolidary-box2SubTitle" />
                        </div>
                    </div>
                    <div className="initial__solidary-modal-desc-box">
                        <div className="initial__solidary-modal-circle">
                            <img src={advantagesIcon} className="solidarity-icon" />
                        </div>
                        <div className="initial__box-title">
                            <FormattedText value="productDescriptionSolidary-box3Title" />
                        </div>
                        <div className="initial__box-desc">
                            <FormattedText value="productDescriptionSolidary-box3SubTitle" />
                        </div>
                    </div>
                </div>
                <div className="initial__solidary-modal-bottom-desc">
                    <FormattedText value="productDescriptionSolidary-bottomText" />
                </div>
            </div>
        );

        return (
            <React.Fragment>
                <OkModalOnboarding
                    overlayClassName="initial__solidary-modal"
                    onClose={() => this.handleOpenSolidaryModal(false)}
                    header={<div className="initial__solidary-modal-header" />}
                    body={content}
                    modalIsOpen={this.state.showSolidaryModal}
                    footer={this.renderSolidaryModalFooter()}
                />
                <div className="row">
                    <div className="col-xs-12">
                        <p className="font-paragraph">
                            <FormattedText value="productDescription-solidary" />
                            <span className="initial__solidary-modal-know-more">
                                <OKLink modifier="emphasize" onClick={() => this.handleOpenSolidaryModal(true)}>
                                    <FormattedText value="productDescriptionSolidary-knowMore" />
                                </OKLink>
                            </span>
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    buildNormalCard(promoCode) {
        const { userProfile, products, wealthProduct, flags } = this.props;
        const cardOffer = this.renderCardOffer(flags.get(OPENCREDIT));
        const isTraditionalUser = userProfile.investmentType === TRADITIONAL;
        const promotionalCode =
            typeof this.props.promotionalCode.get('promotionalCode') !== 'undefined'
                ? this.props.promotionalCode.get('promotionalCode')
                : null;
        const promotionalCodeStatus =
            promotionalCode != null
                ? typeof promotionalCode.get('status') !== 'undefined'
                    ? promotionalCode.get('status')
                    : null
                : null;
        const blockClass = classNames('prospects-gutter product-description prospects-iban', {
            nopadding: null,
        });

        let name = '';
        let topTitle = formatText('productDescription-titleTop');
        let valuesAccountTitle = '';

        if (promoCode || promotionalCodeStatus) {
            name = products.get('productsDescription');

            if (userProfile.valuesAccount && name) {
                name = this.buildBrokerHeader(name);
                valuesAccountTitle = (
                    <div className="title-box__subtitle--broker">
                        <FormattedText value="productDescription-welcomeValuesAccount" />
                    </div>
                );
            }
        } else {
            name = products.get('productsDescription');
        }

        if (wealthProduct.get('wealthType')) {
            topTitle = (
                <strong>
                    <FormattedText value="investmentFund-top" />
                </strong>
            );
            name = this.buildWealthProduct(name);
        }

        const {
            match: {
                params: { code },
            },
        } = this.props;
        const defaultPromoCode = code && decodeURI(code);
        const classPromo = defaultPromoCode ? 'promo-code__details--top' : null;

        const moduloPromoCode =
            this.props.promoCode == null &&
            !userProfile.isJointHolder &&
            userProfile.investmentType !== ROBO &&
            userProfile.investmentType !== GBI ? (
                <div>
                    <PromotionalCode
                        class={classPromo}
                        defaultPromoCode={promoCode}
                        isValid={this.onHandleValidPromoCode}
                        isNotValid={this.onHandleNotValidPromoCode}
                    />
                </div>
            ) : (
                <hr className="promo-code__line" />
            );

        return (
            <div>
                <div className={blockClass}>
                    <div>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="row">
                                    <div className="col-xs-12">
                                        {valuesAccountTitle}
                                        <TitleBox
                                            title={topTitle}
                                            dash="dash"
                                            subTitle={name}
                                            container="--register"
                                            titleModifier="--register"
                                            subTitleModifier="--register"
                                        />
                                    </div>
                                </div>
                                {!isTraditionalUser && (
                                    <p className="product-description-tip">
                                        <FormattedText inline={true} value="productDescription-tipSubtitle" />
                                    </p>
                                )}
                            </div>
                        </div>
                        {cardOffer}
                    </div>
                    {moduloPromoCode}
                </div>
            </div>
        );
    }

    getInvestmentType = () => {
        const {
            location: { pathname },
            actions,
        } = this.props;
        const pathRgx = /^\/hazte-cliente\/inversion-automatizada$/;
        const sanetizedPathName = sanetizeUrl(pathname);

        if (sanetizedPathName === ROBO_PATH || pathRgx.test(pathname)) {
            return ROBO;
        }
        if (sanetizedPathName === GBI_PATH || pathRgx.test(pathname)) {
            return GBI;
        }
        if (sanetizedPathName != null && validateCreditCardPath(pathname)) {
            actions.selectCreditCardSteps();

            return CREDIT_CARD;
        }
        if (sanetizedPathName != null && isCreditCardPathLight(pathname)) {
            actions.selectCreditCardSteps();

            return CREDIT_CARD_LIGHT;
        }

        return TRADITIONAL;
    };

    buildGbiCard() {
        const { userProfile } = this.props;
        const topTitle = <FormattedText value="investmentFund-topGbi" />;
        let subTitle = userProfile.investmentType === GBI ? <FormattedText value="investmentFund-subTitleGbi" /> : null;
        subTitle =
            userProfile.investmentType === ROBO ? <FormattedText value="investmentFund-subTitleRobo" /> : subTitle;
        const textTooltip = <FormattedText value="investmentFund-tooltip" />;
        const tipSubtitleGbi = formatText('productDescription-tipSubtitleGbi');
        const tipParagraphGbi = formatText('productDescription-tipParagraphGbi');
        const blockClass = classNames('prospects-gutter product-description prospects-iban', {
            nopadding: null,
        });

        const moduloPromoCode =
            this.props.promoCode == null && !userProfile.isJointHolder ? (
                <div>
                    <PromotionalCode
                        isValid={this.onHandleValidPromoCode}
                        isNotValid={this.onHandleNotValidPromoCode}
                    />
                </div>
            ) : (
                <hr className="promo-code__line" />
            );

        return (
            <div>
                <div className={blockClass}>
                    <TitleBox
                        title={topTitle}
                        dash="dash"
                        subTitle={subTitle}
                        container="--register"
                        titleModifier="--register"
                        subTitleModifier="--register"
                    />
                    <div>
                        <p className="product-description-tip-robo">{tipSubtitleGbi}</p>
                        <InfoTooltip text={textTooltip} />
                        <br />
                        <p className="product-description-tip-robo">{tipParagraphGbi}</p>
                    </div>
                    <hr />
                    <div>
                        <p className="product-description-tip">
                            <i className="icons icons--icon-info-3"></i>
                            <FormattedText value="productDescription-tip" />
                            <br />
                            <FormattedText value="productDescription-tipGbi" />
                        </p>
                    </div>
                    <br />
                    {moduloPromoCode}
                </div>
            </div>
        );
    }

    buildPromoCodeCard() {
        return (
            <div>
                <PromotionalCode isValid={this.onHandleValidPromoCode} isNotValid={this.onHandleNotValidPromoCode} />
            </div>
        );
    }

    renderCardOffer = openCreditStatus => {
        if (renderSolidaryModal()) {
            return this.renderSolidayModal();
        }

        return openCreditStatus ? this.buildCreditCardOffering() : null;
    };

    render() {
        const {
            userProfile: { investmentType },
            promotionalCode,
            match: {
                params: { code },
            },
            location: { pathname },
            flags,
        } = this.props;
        const promoCode = typeof code !== 'undefined' ? decodeURI(code) : null;
        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);
        const tcDisplayLoginLink = flags.get('tcDisplayLoginLink');
        const creditCardLightType = getCreditCardLightTypeByPath(pathname) || undefined;

        return (
            <Fragment>
                <ConditionalToggling condition={isCreditCardPath(pathname) && userInvestmentType[CREDIT_CARD]}>
                    <CreditCardInitialInfoSection />
                    <CreditCardInitialAdditionalInfoSection tcDisplayLoginLink={tcDisplayLoginLink} />
                    <CreditCardProcessRequeriments />
                </ConditionalToggling>
                <ConditionalToggling condition={isCreditCardPathLight(pathname) && userInvestmentType[CREDIT_CARD]}>
                    <CreditCardLightHeader type={creditCardLightType} />
                </ConditionalToggling>
                <ConditionalToggling condition={userInvestmentType[TRADITIONAL]}>
                    {this.buildNormalCard(promoCode)}
                </ConditionalToggling>
                <ConditionalToggling condition={userInvestmentType[GBI] || userInvestmentType[ROBO]}>
                    {this.buildGbiCard()}
                </ConditionalToggling>
                <InitialStepDispatcher promoCode={null} promotionalCode={promotionalCode} />
            </Fragment>
        );
    }
}

module.exports.constructor = Initial;
module.exports.Initial = connect(
    state => ({
        initialStep: state.initialStep,
        promotionalCode: state.promotionalCode,
        products: state.products,
        wealthProduct: state.wealthProduct,
        cms: state.cms,
        userProfile: state.userProfile,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        productsActions: bindActionCreators(productsActions, dispatch),
        wealthProductActions: bindActionCreators(wealthProductActions, dispatch),
        cmsActions: bindActionCreators(cmsActions, dispatch),
        promotionalCodeAction: bindActionCreators(promotionalCodeAction, dispatch),
        actions: bindActionCreators(stepsActions, dispatch),
    })
)(withFeatureToggling(Initial));
